export default function registerStart (lf) {
  lf.register('start', ({ CircleNode, CircleNodeModel, h }) => {
    class StartNode extends CircleNode {
      getLabelShape () {
        const {model} = this.props
        const {
          x,
          y,width, height
        } = model
        return h(
          "svg",{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:x-25,y:y-25,"width":"50","height":"50","viewBox":"0 0 40 40","fill":"none"},
          h("g",{"opacity":"1","transform":"translate(0 0)  rotate(0 20 20)"}),
          h("g",{"mask":"url(#bg-mask-0)"}),
          h("path",{"id":"分组 1","fill-rule":"evenodd","style":"fill:#2A82E4","transform":"translate(0 0)  rotate(0 20 20)","opacity":"1","d":"M0 20C0 31.04 8.96 40 20 40C31.04 40 40 31.04 40 20C40 8.96 31.04 0 20 0C8.96 0 0 8.96 0 20Z M17.1443 11.3143C16.3543 11.3143 15.7143 11.9543 15.7143 12.7443L15.7143 27.2543C15.7143 27.7943 16.0143 28.2843 16.4843 28.5243C16.9543 28.7743 17.5243 28.7343 17.9643 28.4243L28.3243 21.1743C28.7143 20.9043 28.9443 20.4643 28.9443 20.0043C28.9443 19.5343 28.7143 19.0943 28.3243 18.8243L17.9643 11.5743C17.7243 11.4043 17.4343 11.3143 17.1443 11.3143Z "}),
          h("mask",{"id":"bg-mask-0","fill":"white"}),
          h("use",{"xlink:href":"#path_0"}),
          h("rect",{"id":"path_0","x":"0","y":"0","width":"40","height":"40"}),

        )
      }
      getShape () {
        const {model} = this.props
        const {
          x,
          y,
          r,
          width
        } = model
        const {
          fill,
          stroke,
          strokeWidth} = model.getNodeStyle()
        return h(
          'g',
          {
          },
          [
            h(
              'circle',
              {
                cx: x,
                cy: y,
                width,
                fill,
                stroke,
                strokeWidth
              }
            ),
            this.getLabelShape()
          ]
        )
      }
    }
    class StartModel extends CircleNodeModel {
      // 自定义节点形状属性
      initNodeData(data) {
        data.text = {
          value: (data.text && data.text.value) || '',
          x: data.x,
          y: data.y + 35,
          dragable: false,
          editable: true
        }
        super.initNodeData(data)
        this.r = 20
      }
      // 自定义节点样式属性
      getNodeStyle() {
        const style = super.getNodeStyle()
        return style
      }
      // 自定义锚点样式
      getAnchorStyle() {
        const style = super.getAnchorStyle();
        style.hover.r = 8;
        style.hover.fill = "rgb(24, 125, 255)";
        style.hover.stroke = "rgb(24, 125, 255)";
        return style;
      }
      // 自定义节点outline
      getOutlineStyle() {
        const style = super.getOutlineStyle();
        style.stroke = '#88f'
        return style
      }
      getConnectedTargetRules () {
        const rules = super.getConnectedTargetRules()
        const notAsTarget = {
          message: '起始节点不能作为连线的终点',
          validate: () => false
        }
        rules.push(notAsTarget)
        return rules
      }
    }
    return {
      view: StartNode,
      model: StartModel
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/Admin/Flow/bpmn/registerNode/registerStart.js